import React from "react";
import { Assessment, Course, Lesson } from "src/types/coaching/courses";
import { CourseContentSession } from "src/types/coaching/learners";

export interface CourseReportContextProps {
  startDate: Date;
  endDate: Date;
}

export const CourseReportContext =
  React.createContext<CourseReportContextProps>({
    startDate: new Date(),
    endDate: new Date(),
  });
